export default __webpack_public_path__ + "static/media/mini-metro.985b36d9.webp";